import { Spacing } from '@igs-web/common-ui-components/styles/spacing'
import styled from 'styled-components'

export const FormWrapper = styled.form`
    display: grid;
    grid-gap: ${Spacing.Large};
`
